module.exports = __webpack_public_path__ + "img/01.b2ba1593.jpg";